import { api } from '@/api/core';
import { CASES_LIST_TAG } from '@/api/constants';

export interface MatterAddRequest {
  caseReference: string;
  departmentId: string;
  teamId: string;
  fileHandlerId: string | null;
  clientName: string;
  defendantName?: string;
}

export type MatterAddResponse = {
  matterId: string;
  remainingMattersToday: number;
};

const matterAddApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterAdd: builder.mutation<MatterAddResponse, MatterAddRequest>({
      query: (body) => ({
        url: '/matter/add',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: CASES_LIST_TAG }],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMatterAddMutation } = matterAddApi;
